import { IconButton, Skeleton, styled } from "@mui/material";
import { Margin } from "./small-widgets";

export const ExpandMore = styled((props) => {
    const { expand, title, onClick, ...other } = props;
    return <div className="expand-width expand-more" style={{alignItems: 'center'}} onClick={onClick}><div>{title}</div><div className="child-exp-all-width"/><IconButton onClick={onClick} {...other} /></div>;
  })(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    variants: [
      {
        props: ({ expand }) => !expand,
        style: {
          transform: 'rotate(0deg)',
        },
      },
      {
        props: ({ expand }) => !!expand,
        style: {
          transform: 'rotate(180deg)',
        },
      },
    ],
  }));

export function PreferedCard({title, subtitle, onClick, children}) {
  return <div className="card clickable hover-anim" onClick={() => {onClick()}}>
    <h2>{title}</h2>
    <p>{subtitle}</p>
    <Margin height={10}/>
    {children}
  </div>
}

export function LoadingCard({height}) {
  return <div className="solution-card">
        <Skeleton variant="rounded" width={'100%'} height={height ?? 200} />
    </div>;
}